import { setCollectionItem } from "@/lib/collections";

import { AccountingClass } from "@/typings/accounting";
import store from "@/vuex/store";

const mappedTypes = {
  AccountingClass: AccountingClass
};

export const setVueState = (target: string, data: any) => {
  try {
    let preppedData: any = data;

    // if the incoming data has a type key and it matches a mapping above,
    // then cast the data to the class so that we can use getters etc
    if (data.type) {
      const typeName: string = data.type;

      if (mappedTypes[typeName]) {
        preppedData = new mappedTypes[typeName](data);
      }
    }

    const matches = target.match(/(.*?)\[(.*?)\]/);

    if (matches) {
      // id-indexed collection
      const collection = matches[1];
      const key = matches[2];

      setCollectionItem(collection, key, preppedData);
    } else {
      // simple replace
      store.commit("replace", { state: target, preppedData });
    }
  } catch (e) {
    console.error(e);
  }
};
